"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateFieldAsEnum = validateFieldAsEnum;
const eValidateResponse_1 = require("./eValidateResponse");
/**
 * Validation for a field to check for empty fields, length of input and against a regexp
 *
 * @param val - string: Input to be validated
 * @param minLength - number: The minimum number of characters for the input
 * @param maxLength - number: The maximum number of characters for the input
 * @param regexp - RegExp | null : Tests the input against the regexp
 * @returns return an eValidateResponse
 *
 */
function validateFieldAsEnum(val, minLength = 0, maxLength = 100, regexp) {
    if (val === null || val === undefined) {
        return eValidateResponse_1.eValidateResponse.UndefinedField;
    }
    if (val.length === 0 && minLength > 0) {
        return eValidateResponse_1.eValidateResponse.NotSet;
    }
    if (val.length < minLength && val.length > 0) {
        return eValidateResponse_1.eValidateResponse.MinLengthError;
    }
    if (val.length > maxLength) {
        return eValidateResponse_1.eValidateResponse.MaxLengthError;
    }
    if (regexp && !regexp.test(val)) {
        return eValidateResponse_1.eValidateResponse.RegExpError;
    }
    return eValidateResponse_1.eValidateResponse.OK;
}
